(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-hockey/assets/javascripts/status.js') >= 0) return;  svs.modules.push('/components/themes/sport-hockey/assets/javascripts/status.js'); 
var svs = svs || {};

(function(svs) {
  var logger = new svs.core.log.Logger('svs.themes.sport_hockey');

  svs.themes = svs.themes || {};
  svs.themes.sport_hockey = svs.themes.sport_hockey || {};

  svs.themes.sport_hockey.matchNotice = function(match) {
    if (!match) {
      logger.warn('Invalid parameter to matchNotice, returning empty string.');
      return '';
    }
    var matchStatus;
    switch (match.status) {
      case 16:
        matchStatus = 'Väntar på förlängning';
        break;
      case 18:
        matchStatus = 'Väntar på straffläggning';
        break;
      case 24:
        matchStatus = 'Försenad matchstart';
        break;
      case 25:
        matchStatus = 'Inställd';
        break;
      case 26:
        matchStatus = 'Avbruten';
        break;
      case 28:
        matchStatus = 'Stoppad av domare';
        break;


      default:
        matchStatus = '';
        break;
    }
    return matchStatus;
  };

  svs.themes.sport_hockey.isLive = function(status) {
    if (window.location.href.indexOf('isMocked') > -1) {
      return true;
    }

    return !!_.contains([1, 2, 3, 13, 14, 16, 18, 19, 22], status);
  };

  svs.themes.sport_hockey.isFinished = function(status) {
    return !!_.contains([31, 32, 33, 41], status);
  };

  svs.themes.sport_hockey.isEnded = function(status) {
    return !!_.contains([25, 26, 28, 31, 32, 33, 41], status);
  };
  svs.themes.sport_hockey.subscribeMatch = function(params) {
    return (
      svs.themes.isDateHoursDiff(params.time, -5) &&
      !svs.themes.sport_hockey.isEnded(params.status)
    );
  };

  svs.themes.sport_hockey.hasStarted = function(status) {
    return status > 0 && !_.contains([23, 24, 25], status);
  };

  svs.themes.sport_hockey.isFullTimeOrPassed = function(status, options) {
    options = _.extend(
      {
        includeFullTime: true,
        includePauses: true,
        includeFinished: true
      },
      options
    );

    var statusesForOvertimeOrPenalties = [19, 20, 21, 22];

    if (options.includeFullTime) {
      statusesForOvertimeOrPenalties.push(31, 41);
    }

    if (options.includePauses) {
      statusesForOvertimeOrPenalties.push(16, 17, 18);
    }

    if (options.includeFinished) {
      statusesForOvertimeOrPenalties.push(32, 33);
    }

    return _.contains(statusesForOvertimeOrPenalties, status);
  };

  svs.themes.sport_hockey.getStatusText = function(options) {
    var text = '',
      status;

    options = _.defaults({}, options, {
      statusId: null,
      startTime: null,
      getStartTime: true
    });

    status = options.statusId;

    if (svs.themes.sport_hockey.isLive(status)) {
      switch (status) {
        case 2:
          text = '2:A';
          break;
        case 3:
          text = '3:E';
          break;
        case 14:
        case 16:
        case 18:
          text = 'PAUS';
          break;
        case 19:
          text = 'ÖT';
          break;
        case 22:
          text = 'STR';
          break;
        default:
          text = '1:A';
      }
    } else if (svs.themes.sport_hockey.isEnded(status)) {
      switch (status) {
        case 32:
          text = 'ÖT';
          break;
        case 33:
          text = 'STR';
          break;
        default:
          text = 'FT';
      }
    } else if (options.startTime && options.getStartTime) {
      text = svs.themes.formatTime(options.startTime);
    }

    return text;
  };

})(svs);

 })(window);